import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { BetriebAuswaehlenDialogComponent } from './betrieb-auswaehlen-dialog/betrieb-auswaehlen-dialog.component';
import { BetriebBenutzerZuweisenDialogComponent } from './betrieb-benutzer-zuweisen-dialog/betrieb-benutzer-zuweisen-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { EnterValueDialogComponent } from './enter-value-dialog/enter-value-dialog.component';
import { TimeRangeAuswahlDialogComponent } from './time-range-auswahl-dialog/time-range-auswahl-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
    declarations: [
        ConfirmDialogComponent,
        EnterValueDialogComponent,
        BetriebAuswaehlenDialogComponent,
        BetriebBenutzerZuweisenDialogComponent,
        TimeRangeAuswahlDialogComponent,
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatIconModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatSlideToggleModule,
    ],
    providers: [ConfirmDialogComponent],
})
export class DialogsModule {}
